import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { FileManagementService } from 'src/app/core/services/list-services/file-mangement.service';
import { FileUploadModalService } from 'src/app/core/services/modal-services/file-upload-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { TimelineModel } from '../../../core/models/timeline/timeline.model';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { OwnerEntityType } from 'src/app/core/enums/owner-entity-type-enum';
import { TimeLineType } from 'src/app/core/enums/timeline-type-enum';
import { BaseModel } from 'src/app/core/models/base.model';
import { FileUploadModel } from 'src/app/core/models/file/file-upload-model';

@Component({
  selector: 'app-timeline-note-modal',
  templateUrl: './timeline-note-modal.component.html',
  styleUrls: ['./timeline-note-modal.component.scss']
})
export class TimelineNoteModalComponent extends BaseModalComponent {

  titleName?: string;
  hoursSpent: number = 0;
  minSpent: number = 0;
  eventDescription: string = "";

  confirmReject: boolean = true;

  @Input() timelineItem: TimelineModel = new TimelineModel();
  @Input() ownerEntityType?: OwnerEntityType = undefined;
  @Input() disableModel: boolean = false;

  @Input() otherModel?: any;

  entityTypeId = EntityTypeEnum.TimeLine;

  enumOwnerEntityType = OwnerEntityType;
  enumTimeLineType = TimeLineType;

  constructor(
    protected fileUploadModalService: FileUploadModalService,
    protected fileManagementService: FileManagementService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer,
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  ngOnInit(): void {

    //used for legacy and new notes
    if (this.timelineItem.fileUpload == undefined) {
      this.timelineItem.fileUpload = new FileUploadModel();
    }

    if (this.otherModel == undefined) {
      switch (this.ownerEntityType) {
        case OwnerEntityType.Client:
          this.otherModel = new ClientModel();
          break;
      }
    }

    if (this.timelineItem.timeSpent && this.timelineItem.timeSpent > 0) {
      this.minSpent = this.timelineItem.timeSpent % 60;
      this.hoursSpent = (this.timelineItem.timeSpent - this.minSpent) / 60;
    }
    if (this.timelineItem.type == TimeLineType.Note) {
      this.titleName = "Note"
    } else {
      if (this.timelineItem.name && this.timelineItem.name.split(':')[1]) {
        this.eventDescription = ` Requisition was moved to${this.timelineItem.name.split(':')[1]} by ${this.timelineItem.createdByUserName}`
      } else {
        this.eventDescription = `${this.timelineItem.name}`
      }
      this.titleName = this.timelineItem.name?.split(":")[0]
    }
  }

  ngOnDestroy(): void {
    this.ownerEntityType = undefined;
    this.timelineItem = new TimelineModel();
    this.otherModel = new BaseModel();
  }

  validate(): boolean {
    if (this.timelineItem.name && this.timelineItem.name.length > 0) {

      this.hoursSpent = parseFloat(this.hoursSpent + "") // this is done because it comes back as a string from the input feild, thus we need the numbers out. 
      this.minSpent = parseFloat(this.minSpent + "")

      if (this.hoursSpent + "" == "NaN" || this.hoursSpent < 0) {
        this.hoursSpent = 0;
      }
      if (this.minSpent + "" == "NaN" || this.minSpent < 0) {
        this.minSpent = 0
      }

      if (this.ownerEntityType == OwnerEntityType.Client) {
        if (this.otherModel.id !== undefined) {
          return true;
        }
      } else {
        return true;
      }

    }
    return false;
  }

  onUpdate(): void {
    this.disableEditing = true;
    this.myFileApiService.updateTimelineItem(this.timelineItem).subscribe((result: any) => {
      if (result) {
        this.close();
        this.toasterNotificationService.showSuccess($localize`:@@:Note Updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
      }
      this.disableEditing = false;
    });
  }

  onCreate(): void {
    this.disableEditing = true;
    this.myFileApiService.newTimelineItem(this.timelineItem).subscribe((result: any) => {
      if (result) {
        this.close();
        this.toasterNotificationService.showSuccess($localize`:@@:Note created.`, $localize`:@@Toast_Success_GeneralTitle:Success`);

      }
      this.disableEditing = false;
    });
  }

  override onSave(): void {
    this.submitted = true;
    if (this.validate()) {
      this.timelineItem.type = TimeLineType.Note;
      this.timelineItem.timeSpent = parseFloat(this.hoursSpent + "") * 60 + parseFloat(this.minSpent + "");

      this.timelineItem.ownerEntityType = this.ownerEntityType;

      //first check if other model exists to set the note to that model instead of list component, which is the default .ownerId 
      if (this.otherModel !== undefined && this.otherModel.id !== undefined) {
        this.timelineItem.ownerId = this.otherModel.id;
      }

      if (this.timelineItem.id) {
        this.onUpdate();
      } else {
        this.timelineItem.createdByUserName = this.authMyFileService.currentUserContextValue?.userName;
        this.onCreate();
      }
    } else {
      this.submitted = false
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    }
  }

  clientChosen(result: ClientModel) {
    this.otherModel = result;
  }

  dismiss() {
    this.confirmReject = false;
    this.modalRef.dismiss();
  }

}
